/* OPTICAL INCANTO - Mega Menu JS */
(function () {
  'use strict';
  const HOVER_DELAY_IN  = 80;
  const HOVER_DELAY_OUT = 180;
  let activeItem = null;
  let timerIn = null;
  let timerOut = null;
  let headerHeight = 0;
  const navItems = document.querySelectorAll('.oi-nav__item[data-mega]');
  const panels = document.querySelectorAll('.oi-mega');
  const backdrop = null;
  const header = document.querySelector('header, .site-header, #shopify-section-header');
  const trustBar = document.querySelector('.oi-trust-bar');  if (!navItems.length) return;
  function updateHeaderHeight() {
  var headerH = header ? header.getBoundingClientRect().height : 0;
  var trustH = trustBar ? trustBar.getBoundingClientRect().height : 0;

  headerHeight = headerH + trustH;

  document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  }
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  function openPanel(item) {
    const panelId = item.dataset.mega;
    const panel = document.getElementById(panelId);
    if (!panel) return;
    if (activeItem && activeItem !== item) {
      closePanel(activeItem, true);
    }
    activeItem = item;
    item.classList.add('is-active');
    panel.classList.add('is-visible');
    if (backdrop) backdrop.classList.add('is-visible');
    item.querySelector('.oi-nav__link').setAttribute('aria-expanded', 'true');
  }
  function closePanel(item, immediate) {
    if (!item) return;
    const panelId = item.dataset.mega;
    const panel = document.getElementById(panelId);
    item.classList.remove('is-active');
    if (panel) panel.classList.remove('is-visible');
    if (backdrop) backdrop.classList.remove('is-visible');
    item.querySelector('.oi-nav__link').setAttribute('aria-expanded', 'false');
    if (item === activeItem) activeItem = null;
  }
  function closeAll(immediate) {
    clearTimeout(timerIn);
    clearTimeout(timerOut);
    navItems.forEach(item => closePanel(item, immediate));
  }
  navItems.forEach(function (item) {
    const link = item.querySelector('.oi-nav__link');
    item.addEventListener('mouseenter', function () {
      clearTimeout(timerOut);
      timerIn = setTimeout(function () { openPanel(item); }, HOVER_DELAY_IN);
    });
    item.addEventListener('mouseleave', function () {
      clearTimeout(timerIn);
      timerOut = setTimeout(function () {
        if (!item.classList.contains('panel-hovered')) { closePanel(item); }
      }, HOVER_DELAY_OUT);
    });
    if (link) {
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (item.classList.contains('is-active')) { closePanel(item); } else { openPanel(item); }
        }
        if (e.key === 'Escape') { closeAll(); link.focus(); }
      });
    }
  });
  panels.forEach(function (panel) {
    panel.addEventListener('mouseenter', function () {
      clearTimeout(timerOut);
      const item = document.querySelector('.oi-nav__item[data-mega="' + panel.id + '"]');
      if (item) item.classList.add('panel-hovered');
    });
    panel.addEventListener('mouseleave', function () {
      const item = document.querySelector('.oi-nav__item[data-mega="' + panel.id + '"]');
      if (item) {
        item.classList.remove('panel-hovered');
        timerOut = setTimeout(function () { closePanel(item); }, HOVER_DELAY_OUT);
      }
    });
  });
  if (backdrop) { backdrop.addEventListener('click', function () { closeAll(); }); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  window.addEventListener('scroll', function () { if (activeItem) closeAll(); }, { passive: true });
  // Close custom mega menu whenever any Impulse drawer (cart/search/nav/account) opens.
  document.addEventListener('click', function(e) {
    if (e.target.closest('[class*="js-drawer-open"], [aria-controls="CartDrawer"], [aria-controls="SearchDrawer"], [aria-controls="NavDrawer"]')) closeAll(true);
  }, true);
  const drawerObserver = new MutationObserver(function() {
    if (document.documentElement.classList.contains('js-drawer-open')) closeAll(true);
  });
  drawerObserver.observe(document.documentElement, { attributes:true, attributeFilter:['class'] });
})();
